





















































import { Component, Prop, Mixins } from "vue-property-decorator";

// Mixins
import Context from "@/mixins/context";
import VaultInjectorMixin from "@/mixins/vaultInjectorMixin";

// Types
import { IVaultAsset } from "@/models/vaultAssets";

@Component
export default class VaultAssetDropdownControl extends Mixins(
  Context,
  VaultInjectorMixin
) {
  // Props

  @Prop({ default: null })
  public asset!: IVaultAsset;

  @Prop({ default: false })
  public isDisabled!: boolean;

  // Methods

  public async convertAsset() {
    if (this.isSecret || !!this.asset.label) {
      await this.$vaultMethods.updateVaultAsset(this.asset.id, {
        encrypted: !this.asset.encrypted
      });
      this.$bus.$emit(
        this.asset.encrypted
          ? "vaultAssetsRefreshNotes"
          : "vaultAssetsRefreshSecrets"
      );
      return;
    }

    this.$vaultMethods.openUpdateAssetModal({
      asset: { ...this.asset, encrypted: true },
      isConvertingToSecret: true,
      events: {
        success: () => {
          this.$vaultMethods.refreshData();
          this.$bus.$emit("vaultAssetsRefreshSecrets");
        }
      }
    });
  }

  // Computed

  public get isSecret() {
    return this.asset.encrypted;
  }
}
